import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import styles from "./solutions1.module.css";

import tepl_korrekt from "../../files/images/teploschetchik_korrektor.png";
import elekt_schetch from "../../files/images/elektroschetchiki.png";
import vodo_schetch from "../../files/images/vodoschetchiki.png";

class Solutions1 extends React.Component {
  render() {
    const { detect } = require("detect-browser");
    const browser = detect();
    const firefox = browser.name === "firefox";

    return (
      <div className={styles.container} style={{ paddingBottom: firefox ? "5em" : "2em" }}>
        <div>
          Наша компания разрабатывает автоматизированные системы коммерческого
          учета энергоресурсов (АСКУЭ):
        </div>

        <ul>
          <li>тепла;</li>
          <li>газа;</li>
          <li>воды;</li>
          <li>электроэнергии;</li>
          <li>комплексные системы учета энергоресурсов.</li>
        </ul>
        <br />
        <div>Области применения АСКУЭ:</div>

        <ul>
          <li>промышленность;</li>
          <li>жилищно-коммунальное хозяйство;</li>
          <li>дачные и коттеджные поселки.</li>
        </ul>
        <br />
        <div>Возможны два варианта диспетчеризации:</div>

        <ul>
          <li>
            <Link to="/solutions1#buysystem">
              покупка диспетчерской системы;
            </Link>
          </li>
          <li>
            <Link to="/solutions1#onlinesystem">
              работа с диспетчерской системой через наш сайт
              www.teplo-inform.ru.
            </Link>
          </li>
        </ul>
        <br />
        <div className={styles.caption2}>
          <a href="#buysystem" id="buysystem" />
          Автоматизированная Система Коммерческого Учета Энергоресурсов
          «Теплоинформ»
        </div>
        <br />
        <div>
          «Теплоинформ» - профессиональная система учета энергоресурсов, она
          может работать в масштабах предприятия, района, города. Доступ к
          данным системы происходит в локальной сети или через через интернет.
        </div>
        <br />
        <div className={styles.caption2}>
          Основные возможности системы «Теплоинформ»
        </div>
        <br />
        <div>Подключение к системе:</div>
        <ul>
          <li>до 50 000 счетчиков тепла;</li>
          <li>до 50 000 счетчиков газа;</li>
          <li>до 500 000 счетчиков электрической энергии;</li>
          <li>до 500 000 счетчиков воды;</li>
        </ul>
        <div>
          Совместимые приборы (подробнее см.{" "}
          <Link to="/hmeters">каталог совместимых счетчиков</Link>):
        </div>
        <ul>
          <li>
            <span style={{ textDecoration: "underline" }}>Теплосчетчики:</span>{" "}
            ВИС.Т, КМ-5, SA-94/1, SA-94/2M, SA-94/3, ТЭМ-104, ТЭМ-106, ТЭМ-05М,
            Магика, ТАРАН-Т, РПТ-1100, РПТ-2200M, Ирвикон, ВКТ-5, ВКТ-7, ЭСКО-Т,
            Взлет-ТСР, Логика СПТ961, ТеРосс-ТМ, СТД, УВП-280.
          </li>
          <li>
            <span style={{ textDecoration: "underline" }}>
              Корректоры объема газа:
            </span>{" "}
            СПГ-761, СПГ-762, СПГ-763, Комплексы многониточные измерительные
            микропроцессорные «Суперфлоу-IIET», SEVC-D, GVC.
          </li>
          <li>
            <span style={{ textDecoration: "underline" }}>
              Счетчики электрической энергии:
            </span>{" "}
            ПСЧ-3АР.05, ПСЧ-4ТАК, ПСЧ-4РП.05.2, Меркурий 203.3T, Меркурий 230AR.
          </li>
          <li>
            <span style={{ textDecoration: "underline" }}>
              Расходомеры-счетчики:
            </span>{" "}
            УРСВ-010М, ВЗЛЕТ РС, УСРВ, ВЗЛЕТ МР, ВЗЛЕТ ЭР, РМ-5.
          </li>
          <li>
            <span style={{ textDecoration: "underline" }}>Водосчетчики:</span>{" "}
            любые водосчетчики с импульсным выходом, подключение через
            РадиоПульсар.
          </li>
        </ul>
        <br />
        <div>
          Разработка драйвера для другого типа счетчика производится бесплатно.
        </div>
        <br />
        <div>Функциональные возможности системы «Теплоинформ»:</div>
        <ul>
          <li>Хранение суточных и часовых архивов, текущих значений;</li>
          <li>
            Автоматический контроль неисправностей приборов и нештатных
            ситуаций;
          </li>
          <li>Автоматический контроль качества энергоресурсов;</li>
          <li>Автоматическая синхронизация премени приборов;</li>
          <li>Резервирование компонент системы;</li>
          <li>Стыковка с биллинговыми системами.</li>
        </ul>
        <br />
        <div>
          Сбор данных и связь с приборами осуществляется одним или несколькими
          серверами. Если серверов несколько, то они полностью взаимозаменяемы,
          что повышает надежность и производительнось системы.
        </div>
        <br />
        <div>
          Система "Теплоинформ" может передавать данные в биллинговую систему,
          что позволят полностью автоматизировать процесс коммерческого учета
          энергоресурсов.
        </div>
        <br />
        <div>
          Сбор данных с приборов происходит по настраиваемым расписаниям:
        </div>
        <ul>
          <li>в определенные дни месяца;</li>
          <li>ежедневно;</li>
          <li>в определенные часы суток;</li>
          <li>периодически;</li>
          <li>по требованию оператора.</li>
        </ul>

        <div className={styles.caption2}>Организация связи с приборами</div>
        <br />
        <div>
          Сбор данных со счетиков может производиться по различным каналам
          связи:
        </div>
        <ul>
          <li>Пакетная передача данных GPRS;</li>
          <li>Передача данных по голосовому каналу CSD;</li>
          <li>Интернет;</li>
          <li>Локальная компьютерная сеть;</li>
          <li>Радиосвязь;</li>
          <li>Проводные телефонные линии.</li>
        </ul>
        <div>
          Из поддерживаемых типов связи наиболее эффективными являются является
          GPRS и локальная компьютерная сеть.
        </div>
        <br />
        <div>
          При связи по GPRS, обмен данными между серверами системы «Теплоинформ»
          и теплосчетчиками происходит внутри виртуальной корпоративной сети,
          создаваемой оператором сотовой связи. Доступ в эту сеть происходит по
          шифрованному каналу, что обеспечивает высокую степень защиты
          информации. Преимущества этого типа связи - отсутствие необходимости в
          прокладке дополнительных кабелей связи, невысокая стоимость передачи
          данных.
        </div>
        <br />
        <div>
          При связи через локальную компьютерную сеть, необходимо подвести к
          кажому теплосчетчику кабель Ethernet, и оснастить его преобразователем
          Ethernet-RS232. В этом случае обмен данными происходит внутри
          локальной компьютерной сети и может быть защищен ограничением связи по
          IP-адресу сервера. Преимущества этого вида связи - высокая скорость
          передачи данных, надежность соединения.
        </div>
        <br />
        <div>
          Для диспетчеризации близко расположенных объектов (расстояние между
          соседними объектами не более 300м.) подойдет радиосвязь по технологии
          ZigBee.
        </div>
        <br />
        <div>
          Если на объекте диспетчеризации отсутствует электропитание, то в этом
          случае можно использовать модем AnCom RM/D с микропотреблением
          энергии. Модем большую часть времени находится в "спящем режиме" и
          выходит на связь раз в сутки или реже для передачи новых данных. Время
          работы модема до смены элемента питания составляет 1 год.
        </div>
        <br />
        <div className={styles.caption}>
          Связь с теплосчетчиками и корректорами объема газа
        </div>
        <br />
        <div>
          Для теплосчетчиков и счетчиков газа, как правило, необходима установка
          устройства связи для каждого прибора. Выбор типа связи зависит от
          объекта диспетчеризации. (см. рис.)
          <div>
            <img src={tepl_korrekt} alt="teploschetchik korrektor image"
              style={{ width: "41.8em", height: "auto" }} />
          </div>
          <br />
          <div className={styles.caption}>
            Связь со счетчиками электрической энергии
          </div>
          <br />
          <div>
            Для счетчиков электрической энергии наиболее эффективным является
            организация связи по RS-485, CAN или PLC (передача данных по
            электрическим линиям). В этом случае устанавливается один
            концентратор на максимум 1024 электросчетчика, расположенных
            достаточно близко друг от друга (многоквартирный дом, дачный
            поселок). Далее из концентратора информация по каналу GSM/GPRS или
            интернет передается в сервер сбора данных.
          </div>
          <div>
            При связи по RS-485 и CAN необходимо подключение всех приборов к
            общей шине - медной витой паре. Связь PLC более удобна, так как
            передача данных происходит по уже имеющимся силовым линиям на
            частотах 50-100 кГц, но качество ее работы существенно зависит от
            параметров электросети. (см. рис.)
          </div>
          <div>
            <img src={elekt_schetch} alt="elektroschetchiki image"
              style={{ width: "53.4em", height: "auto" }} />
          </div>
          <br />
          <div className={styles.caption}>Связь с водосчетчиками</div>
          <br />
          <div>
            Для сбора данных с теплосчетчиков необходимо, чтобы они имели
            импульсный выход. К импульсному выходу подключается модуль
            РадиоПульсар. Модуль РадиоПульсар имеет автономное питание от
            батарейки 9В (смена необходима в течение 2-3 лет) и выполняет
            подсчет импульсов и передачу их на концентраторы РадиоПульсар,
            расположенные на лестничных клетках дома. Концентраторы в свою
            очередь объединены по RS-485 или радиоканалу и передают собранную
            информацию на общедомовой концентратор. Из него информация по каналу
            GSM/GPRS или интернет передается на сервер сбора данных. (см. рис.)
          </div>
          <div>
            <img src={vodo_schetch} alt="vodoschetchiki image"
              style={{ width: "53.4em", height: "auto" }} />
          </div>
          <br />
          <div className={styles.caption2}>Дополнительные функции</div>
          <br />
          <div>
            Система «Теплоинформ» может дополнительно выполнять функции охранной
            и пожарной сигнализации на узлах учета энергоресурсов. Для этого
            используются GSM/GPRS модемы AnCom RM/D, к которым можно подключить
            до 8 аналоговых или дискретных датчиков:
          </div>
          <ul>
            <li>датчик проникновения;</li>
            <li>датчик наличия электропитания;</li>
            <li>датчик задымления;</li>
            <li>датчик затопления;</li>
            <li>датчик температуры наружного воздуха;</li>
            <li>датчики давления теплоносителя.</li>
          </ul>
          <div>
            При срабатывании датчика, высылается SMS-сообщение с описанием
            события.
          </div>
        </div>
        <br />
        <div className={styles.caption2}>Работа с системой «Теплоинформ»</div>
        <div>
          Работать с системой «Теплоинформ» можно с компьютера, на котором она
          установлена, так и с любого другого компьютера в локальной сети.
          Работа с системой происходит через веб-интерфейс, поэтому на
          клиентских местах не нужно устанавливать специальное ПО.
        </div>
        <br />
        <div>
          Одна из наиболее интересных возможностей системы «Теплоинформ» -
          доступ через интернет. Для этого необходимо установить ее на сервер с
          публичным IP-адресом, после этого начинает работь веб-сайт системы.
        </div>
        <br />
        <div>
          Посещать веб-сайт могут все заинтересованные в информации специалисты:
        </div>
        <ul>
          <li>представители абонентов - потребителей энергоресурсов;</li>
          <li>представители сервисных организаций;</li>
          <li>представители энергоснабжающих компаний.</li>
        </ul>
        <div>
          Работа с системой «Теплоинформ» происходит в личном кабинете, войти в
          который можно по персональному паролю. В личном кабинете каждому
          пользователю (абонент, сервисная компания, энергоснабжающая компания)
          доступны только те теплосчетчики, за которые он отвечает. Для защиты
          личных кабинетов с большим количеством тепосчетчиков используются
          другие методы защиты.
        </div>
        <br />
        <div>Через веб-сайт доступны все функции системы «Теплоинформ»:</div>
        <ul>
          <li>
            Получение отчетных ведомостей в формате Excel. Ведомости могут
            содержать часовые или суточные данные;
          </li>
          <li>
            Получение отчетных ведомостей по группе абонентов ZIP-архивом;
          </li>
          <li>Получение общей ведомости по группе абонентов;</li>
          <li>
            Сведение баланса между общим счетчиком и счетчиками потребителей;
          </li>
          <li>Чтение текущих значений в реальном времени;</li>
          <li>Чтение архивов в реальном времени;</li>
          <li>Просмотр данных в виде графиков;</li>
        </ul>
        <div>
          Все подключенные к системе приборы можно просмотривать на
          интерактивной географической карте. В качестве карт используются
        </div>
        <ul>
          <li>карты Google;</li>
          <li>открытые карта OpenStreetMap;</li>
          <li>карты Заказчика.</li>
        </ul>

        <div className={styles.caption}>
          Возможности системы при работе с теплосчетчиками
        </div>
        <br />
        <div>
          Если система конфигуриуется для работы с теплосчетчиками, то она может
          хранить температуру наружного воздуха с интервалом до 1 часа.
          Температуру наружного воздуха можно получать или с теплосчетчика, к
          которому подключен соответствующий датчик или из интернета. Знание
          температуры наружного воздуха позволяет:
        </div>
        <ul>
          <li>контролировать температурный график;</li>
          <li>анализировать качество регулирования.</li>
        </ul>
        <div>
          Система «Теплоинформ» автоматически анализирует качество регулирования
          ИТП и выдает отчет об объектах, потребление тепла на которых не
          согласуется с наружной температурой.
        </div>
        <br />
        <div className={styles.caption}>
          Возможности при работе с корректорами объема газа
        </div>
        <br />
        <div>
          Система "Теплоинформ" позволяет удаленно менять теплотворную
          способность газа, если тип корректора это позволяет.
        </div>
        <br />
        <div className={styles.caption}>
          Возможности при работе с электросчетчиками
        </div>
        <br />
        <div>
          При работе с электросчетчиками, система "Теплоинформ" позволяет:
        </div>
        <ul>
          <li>
            просматривать профиль мощности (потребление электроэнергии по
            получасам);
          </li>
          <li>
            удаленно отключать нагрузку электросчетчика (если тип
            электросчетчика это позволяет).
          </li>
        </ul>
        <div className={styles.caption2}>
          Автоматический контроль нештатных ситуаций
        </div>
        <br />
        <div>
          При организации учета тепла с помощью теплосчетчиков, очень важно
          следить за корректностью их работы и нештатными ситуациями. Для этого
          производят регулярные обходы ЦТП и снятие показаний с прибор учета.
          Применение диспетчерской системы "Теплоинформ" позволяет существенно
          сократить количество обходов ЦТП и уменьшить ручную работу. Система
          «Теплоинформ» автоматически контролирует работу теплосчетчиков и
          выявляет большое число нештатных ситуаций:
        </div>
        <ul>
          <li>утечка;</li>
          <li>подмес;</li>
          <li>нарушение температурного графика;</li>
          <li>нарушение договорных пределов;</li>
          <li>остановка счета;</li>
          <li>неисправность прибора;</li>
          <li>любые другие условия, задаваемые пользователем.</li>
        </ul>
        <div>
          Все зафиксированные события можно посмотреть на сайте или оперативно
          получить:
        </div>
        <ul>
          <li>SMS-сообщением на мобильный телефон;</li>
          <li>мгновенным сообщением через интернет;</li>
          <li>по электронной почте.</li>
        </ul>
        <div className={styles.caption2}>Выгоды от использования системы</div>
        <br />
        <div className={styles.caption}>Для энергоснабжающих компаний</div>
        <br />
        <div>
          С помощью системы «Теплоинформ» можно полность автоматизировать сбор
          данных с приборов учета и перейти к электронному документообороту.
          Получаемые выгоды:
        </div>
        <ul>
          <li>уменьшение количества необходимых обходов абонентов;</li>
          <li>повышение контроля за потреблением энергоресурсов;</li>
          <li>повышение прозрачности процесса выставления счетов на оплату;</li>
          <li>оперативный разбор спорных ситуаций.</li>
        </ul>
        <div className={styles.caption}>Для абонентов и сервисных компаний</div>
        <br />
        <div>
          При развертывании системы «Теплоинформ» абоненты и сервисные
          организации получают удобный доступ к учетным данным через веб-сайт.
          Выгоды от этого:
        </div>
        <ul>
          <li>контроль за работой приборов учета и любого места;</li>
          <li>получение оперативных оповещений и нештатных ситуациях;</li>
          <li>повышение энергоэффективности;</li>
          <li>оперативный разбор спорных ситуаций.</li>
        </ul>
        <div>
          Вы можете оценить работу системы «Теплоинформ» в{" "}
          <Link to="/login">
            тестовом личном кабинете
            </Link>
          .
        </div>
        <div>Для входа используйте Имя - «Тест», пароль - «Тест».</div>
        <br />
        <div>
          Если Вы хотите узнать больше о системе -{" "}
          <Link to="/contacts">
            обращайтесь к нам.
            </Link>
        </div>
        <br />
        <div className={styles.caption2}>
          Работа с АСКУЭ «Теплоинформ» через сайт{" "}
          <span style={{ textDecoration: "underline" }}>
            www.teplo-inform.ru
          </span>
        </div>
        <br />
        <div>
          Если у Вас нет желания покупать и устанавливать диспетчерскую систему
          на свой сервер, то вы можете организовать учет энергоресурсов on-line
          через наш сайт{" "}
          <a
            href="http://www.teplo-inform.ru/"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.teplo-inform.ru
          </a>
          . Для этого необходимо оснастить приборы учета устройствами связи
          (GPRS-модемы или подключение к интернету). Сбором данных с приборов
          будут заниматься промышленные сервера ООО «Теплоинформ». Надежность
          системы обеспечивается резервированием серверов и каналов связи.
        </div>
        <br />
        <div>
          <a href="#onlinesystem" id="onlinesystem" />
          Работа с диспетчерской системой происходит на нашем сайте в личном
          кабинете, доступ в который открывается по персональному паролю. В
          личном кабинете доступны основные функции системы «Теплоинформ».
          Услуги по диспетчеризации через наш сайт предоставляются при
          заключении договора и оплаты в соответствии с{" "}
          <Link to="/tariffs">
            тарифами
            </Link>
          .
        </div>
        <br />
        <div>
          Вы можете оценить работу системы «Теплоинформ» в{" "}
          <Link to="/login">
            тестовом личном кабинете
            </Link>
          .
        </div>
        <div>Для входа используйте Имя - «Тест», пароль - «Тест».</div>
        <br />
        <div>
          Если Вы хотите узнать больше о системе -{" "}
          <Link to="/contacts">
            обращайтесь к нам
            </Link>
          .
        </div>
      </div>
    );
  }
}

export default Solutions1;
